export const LIGHT_PAGE_PATHS = [
  "/",
  "/offres",
  "/projets",
  "/guides",
  "/mentions-legales",
  "/politique-de-confidentialite",
  "/cgv",
  "/cgu",
] as const;

export const GUIDE_CATEGORY_FILTERS = [
  "Tous",
  "Site vitrine",
  "Budget",
  "Guide agence",
  "Méthode",
  "Refonte",
  "SEO",
  "Automatisation",
  "E-commerce",
  "Stratégie",
] as const;

export function isLightPage(pathname: string): boolean {
  if ((LIGHT_PAGE_PATHS as readonly string[]).includes(pathname)) return true;
  return pathname.startsWith("/guides");
}

export const HERO_GRADIENT_TEXT =
  "bg-gradient-to-r from-emerald-600 via-teal-600 to-green-600 bg-clip-text text-transparent";

export const SECTION_TITLE_CLASS =
  "mx-auto max-w-4xl text-balance text-[1.5rem] font-bold leading-[1.08] tracking-[-0.04em] sm:text-3xl md:text-4xl md:leading-[1.05]";
